import { Skeleton } from "@ui/shad"

export default function TaskSkeleton() {
  return (
    <div className="space-y-6">
      <div className="flex items-start gap-2">
        <Skeleton className="mt-1 size-6 flex-none rounded-full" />
        <div className="grow space-y-2">
          <Skeleton className="h-[30px] w-3/4" />
        </div>
      </div>

      <div className="space-y-2">
        <div className="rounded-lg border border-transparent px-2 py-1">
          <Skeleton className="h-20 w-full" />
        </div>
      </div>

      <div className="space-y-3">
        <div className="grid grid-cols-[100px_1fr] items-center">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-8 w-32" />
        </div>
        <div className="grid grid-cols-[100px_1fr] items-center">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-8 w-28" />
        </div>
        <div className="grid grid-cols-[100px_1fr] items-center">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-8 w-24" />
        </div>
      </div>
    </div>
  )
}
